<template>
      <v-card v-if="faq.length">
        <v-card-title class="primary white--text">Часто задаваемые вопросы</v-card-title>
        <v-expansion-panels v-if="faq.length">
          <v-expansion-panel v-for="(item, i) in faq" :key="i">
            <v-expansion-panel-header><b>{{item.question}}</b></v-expansion-panel-header>
            <v-expansion-panel-content>
              <span v-html="item.answer"></span>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-card-text class="text-center" v-if="!faq.length && loading">
          <v-progress-circular
              class="mt-5"
              :width="3"
              color="#0075a8"
              indeterminate
          ></v-progress-circular>
        </v-card-text>
      </v-card>
</template>

<script>
export default {
  name: 'Faq',
  computed: {
    faq() {
      return this.$store.state.faq;
    },
  },
  mounted() {
    this.$store.dispatch('GetFaq');
  },
};
</script>

<style scoped>

</style>